var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banners"},_vm._l((_vm.banners),function(banner,index){return _c('a',{key:index,staticClass:"banner",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.jumpUrl(banner.configer)}}},[_c('img',{attrs:{"src":banner.configer.img}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }